const SET_RECOVERY_MASKED_DATA = 'AUTH/SET_RECOVERY_MASKED_DATA'
const SET_RECOVERY_STEP = 'AUTH/SET_RECOVERY_STEP'
const SET_RECOVERY_REQUESTID = 'AUTH/SET_RECOVERY_REQUESTID'

export { SET_RECOVERY_STEP, SET_RECOVERY_REQUESTID, SET_RECOVERY_MASKED_DATA }
